import Comp from './comp'
import './index.less'


export default Comp
